export const MAX_CARD_SUGGESTIONS_EXPERIMENT = 5
export const MAX_GIFT_SUGGESTIONS_EXPERIMENT = 3
export const MAX_FLOWERS_AND_PLANTS_SUGGESTIONS_EXPERIMENT = 3
export const MAX_SUGGESTIONS = 10
export const MAX_ALL_SUGGESTIONS =
  MAX_CARD_SUGGESTIONS_EXPERIMENT +
  MAX_GIFT_SUGGESTIONS_EXPERIMENT +
  MAX_FLOWERS_AND_PLANTS_SUGGESTIONS_EXPERIMENT
export const MAX_NAVIGATIONAL_SUGGESTIONS = 1
export const DEFAULT_SEARCH_DEPARTMENT = 'all_cards'
export const DEFAULT_TAB_NAME = 'All'
